/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../../lib/amplify-client';

export interface UpdateMarketingOptinsInput {
  optin_general: boolean;
  optin_drops: boolean;
}

export interface UpdateMarketingOptinsResult {
  optin_general: boolean;
  optin_drops: boolean;
  has_state: boolean;
}

/**
 * Flip marketing opt-in flags for the currently authenticated user.
 *
 * Calls the `updateMarketingOptins` AppSync mutation (Phase 2a) which
 * creates the MARKETING_STATE row on first call (with an HMAC unsubscribe
 * token), otherwise flips changed flags via setOptin. Invalidates the
 * profile cache on success so the new `marketing_state` propagates to the
 * Notifications section and home banner.
 */
export function useUpdateMarketingOptinsMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (
      input: UpdateMarketingOptinsInput,
    ): Promise<UpdateMarketingOptinsResult> => {
      const resp = await (client as any).mutations.updateMarketingOptins(input, {
        authMode: 'userPool',
      });
      if (resp.errors?.length) {
        throw new Error(
          resp.errors.map((e: { message: string }) => e.message).join('; '),
        );
      }
      const data = resp.data;
      if (!data) throw new Error('updateMarketingOptins returned no data');
      return data as UpdateMarketingOptinsResult;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['profile'] });
    },
  });
}
